export default __webpack_public_path__ + "349560c43c6be5d6d8f87b1281365db8.svg";